import BackgroundProcess from "./MainComponent.vue";
import { type InjectionKey, type Ref } from "vue";

export const CODE_LABELS: Readonly<Record<string, string>> = {
  "/dedicated-services/export": "Download Dedicated Services Columns",
  "/dedicated-services/invoices/expense-summary":
    "Download Dedicated Services Expense Summary",
  "/dedicated-services/invoices/income-summary":
    "Download Dedicated Services Income Summary",
  "/dedicated-services/invoice-line-items/bulk":
    "Add Billable Item To Dedicated Services",
  "/dedicated-services/invoice-line-items/recalculate":
    "Recalculate Dedicated Services Billing",
  "/dedicated-services/statuses/export":
    "Download Dedicated Services Status History",
  "/incidences/bulk": "Open Multiple Incidences",
  "/incidences/export": "Download Incidences Columns",
  "/invoice-line-items/bulk": "Add Multiple Billable Items",
  "/linehauls/export/orders": "Download Linehaul Orders",
  "/linehauls/statuses/export": "Download Linehauls Status History",
  "/orders/articles/export": "Download Order Articles",
  "/orders/attachments/bulk": "Attach File To Multiple Orders",
  "/orders/comments/bulk": "Add Comment To Multiple Orders",
  "/orders/delivery-notes/bulk": "Download Delivery Notes",
  "/orders/invoices/expense-summary": "Download Orders Expense Summary",
  "/orders/invoices/income-summary": "Download Orders Income Summary",
  "/orders/invoices": "Generate Order Invoices",
  "/orders/labels/bulk": "Download Shipping Labels",
  "/orders/statuses/bulk": "Change Orders Statuses",
  "/orders/statuses/export": "Download Orders Status History",
  "/orders/bulk": "Change Orders Details",
  "/orders/export": "Download Orders Columns",
  "/orders/invoice-line-items/recalculate": "Recalculate Orders Billing",
  "/orders/invoice-line-items/bulk": "Add Billable Item To Orders",
  "/routes/export": "Download Last Mile Routes",
};

export enum status {
  pending = "pending",
  done = "done",
  failed = "failed",
}

export const jobsKey = Symbol() as InjectionKey<Ref<Auth.JobUI[]>>;

export default BackgroundProcess;
